import { useContext, useMemo } from "react";
import { StudyContext } from "../../../../context/studyData/studyData";

/**
 * Normalized patient / accession / gender strings from the current study for CRE mirror payloads.
 */
export function useCreMirrorPatientSummary() {
  const { studyData } = useContext(StudyContext);

  return useMemo(() => {
    const d = studyData;
    if (!d || typeof d !== "object") {
      return { patientName: "", accessionNo: "", gender: "" };
    }
    const patientName =
      (typeof d.patientName === "string" && d.patientName.trim()) ||
      [d.firstName, d.lastName].filter(Boolean).join(" ").trim() ||
      "";
    const accessionNo =
      (typeof d.accessionNo === "string" && d.accessionNo.trim()) ||
      (typeof d.accNo === "string" && d.accNo.trim()) ||
      "";
    const gender =
      (typeof d.patientSex === "string" && d.patientSex.trim()) ||
      (typeof d.gender === "string" && d.gender.trim()) ||
      "";
    return { patientName, accessionNo, gender };
  }, [studyData]);
}
